import banner from "../../assets/img/service-banner3.avif";
const data = [
  {
    title: "Target Market & Technical Feasibility Analysis",
    description:
      "Identifying suitable markets based on regulatory requirements, technical standards, and logistical viability.",
  },
  {
    title: "Regulatory & Compliance Strategy",
    description:
      "Ensuring alignment with international standards (e.g., ISO, ICAO, IATA), customs regulations, and product certifications for seamless cross-border operations.",
  },
  {
    title: "Product and System Adaptation",
    description:
      "Supporting necessary product modifications, certifications, and documentation to meet foreign technical specifications and import/export controls.",
  },
  {
    title: "Supply Chain Engineering",
    description:
      "Designing and implementing supply chain structures tailored to complex technical products—focusing on reliability, traceability, and risk management.",
  },
  {
    title: "Logistics Architecture & Risk Planning",
    description:
      "Structuring logistics flows, transport modes, insurance, warehousing, and handling requirements with technical equipment and high-value components in mind.",
  },
  {
    title: "Export Packaging & Handling Requirements",
    description:
      "Advising on material protection, documentation, and shipment preparation for sensitive or specialized equipment (e.g., tools, GSE, electronic components).",
  },
  {
    title: "Customs Process Engineering",
    description:
      "Mapping import/export procedures, classifications (HS codes), and country-specific documentation requirements for efficient clearance.",
  },
  {
    title: "Trade Documentation & Contractual Structuring",
    description:
      "Drafting or reviewing technical annexes, Incoterms usage, delivery schedules, and maintenance/service obligations in trade agreements.",
  },
  {
    title: "International Procurement & Sourcing Strategy",
    description:
      "Identifying qualified suppliers and partners that meet performance, quality, and compliance benchmarks—especially for aviation-grade or industrial components.",
  },
  {
    title: "Integrated Operations Outsourcing",
    description:
      "Managing the entire import/export process on your behalf—from regulatory clearances to end-point delivery, tailored to your technical workflows.",
  },
  {
    title: "Mentorship & Technical Training",
    description:
      "Providing structured training on international trade regulations, technical import/export procedures, and operational readiness for your team.",
  },
  {
    title: "Custom-Tailored Technical Solutions",
    description:
      "Delivering bespoke consulting services based on your industry, product type, and operational footprint.",
  },
];

const ExportImport = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>
              Strategic Import & Export Consulting with Technical Precision
            </h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Strategic Import & Export Consulting with Technical Precision"
                className="img-fluid"
                title="Strategic Import & Export Consulting with Technical Precision"
              />
              <p>
                At GGAS Maintenance Tooling &amp; Equipments (GGAS), we
                recognize that international trade is not just about moving
                goods—it's about managing complexity, ensuring compliance, and
                building robust systems that support sustainable global
                operations.
              </p>
              <p>
                Our import and export consulting services are designed for
                technically driven businesses that require precision, regulatory
                adherence, and operational efficiency across borders. Whether
                you’re establishing new international trade routes or optimizing
                existing operations, our team brings deep technical expertise to
                every phase of your project.
              </p>
            </div>
            <div className="body">
              <h4>
                Our Core Technical Import & Export Consulting Solutions Include
              </h4>
              <div className="row">
                {data.map((item, i) => {
                  return (
                    <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                      <div className="serviceItemCard">
                        <h6>{item.title}</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="footer">
              <h4>Import and Export Support Built on Engineering Insight</h4>
              <p>
                At GGAS, we combine global trade expertise with
                engineering-level precision. Whether you’re dealing with
                aerospace parts, industrial machinery, GSE, or specialized
                tools, our approach ensures that your international operations
                are technically compliant, logistically sound, and strategically
                aligned.
              </p>
              <p>
                Let us support your global supply chain transformation. Contact
                us to explore tailored import/export consulting solutions
                designed for technically demanding environments.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExportImport;
